async function e(a) {
  const r = await a.arrayBuffer(), t = await crypto.subtle.digest("SHA-256", r);
  return Array.from(new Uint8Array(t)).map((s) => s.toString(16).padStart(2, "0")).join("");
}
export {
  e as hashFile
};
